export const viewNamePrefix = 'UBM';
